import { useContext } from "react";
import { BillingInformationContext } from "../../Account/BillingInformation/BillingInformationContext";
import { useGiftCardApplyForm } from "../GiftCardApply/useGiftCardApplyForm";
import { useCheckoutCouponModal } from "../Coupon/useCheckoutCouponModal";
import { useFormContext } from "react-hook-form";
import { usePaymentMethods } from "../../SWR/Payments/usePaymentMethods";
export const usePaymentSection = () => {
    const { control, setValue, getFieldState, formState, watch, clearErrors } = useFormContext();
    const { error: paymentMethodError } = getFieldState("paymentMethod", formState);
    // Get payment data from SWR
    const { customerCreditCards, primaryCreditCard } = usePaymentMethods();
    // Get UI state from context
    const { addedNewCard, setAddedNewCard, publicKey, stripePublishableKey, clientSecret, setClientSecret, paymentIntentId, dismissedAddPaymentModal, setDismissedAddPaymentModal, token, paymentProcessor, } = useContext(BillingInformationContext);
    const { showCouponForm } = useCheckoutCouponModal();
    const giftCardModalProps = useGiftCardApplyForm();
    return {
        customerCreditCards,
        addedNewCard,
        clientSecret,
        setClientSecret,
        stripePublishableKey,
        publicKey,
        paymentIntentId,
        control,
        watch,
        clearErrors,
        setValue,
        paymentMethodError,
        primaryCreditCard,
        setAddedNewCard,
        showCouponForm,
        giftCardModalProps,
        dismissedAddPaymentModal,
        setDismissedAddPaymentModal,
        token,
        paymentProcessor,
    };
};
